module.exports = __webpack_public_path__ + "assets/img/service7.e91f1f81.png";